import ssnModelValidator from 'forms/shared/validators/models/ssn/ssn';
import { INVALID_SSN } from 'constants/errors';
import { SSNModel } from 'forms/shared/types';
import { includesInvalidSSN } from 'constants/invalidSSNList';
import { BaseCustomValidator } from '../types';

const ssnBaseValidator: BaseCustomValidator<SSNModel> = (validateModel, validate) => function (
  value,
  options,
  key,
  attributes,
  globalOptions
) {
  if (validate.isEmpty(value)) { return null; } // Don't validate if there is no value

  const {
    first, middle, last, notApplicable
  } = value;

  if (notApplicable === true) { return null; }

  const ssnErrors = validateModel(value, ssnModelValidator, { ...globalOptions, ...options });
  if (ssnErrors !== true) { return ssnErrors; }

  if (includesInvalidSSN(first, middle, last)) { return INVALID_SSN; }

  return null;
};

export default ssnBaseValidator;
